<template>
  <div class="message-request-modal" v-if="isOpen">
    <div class="message-request-wrapper">
      <a
        data-w-id="150735b1-3e6f-fc67-a109-a12e2e2f0ba7"
        href="#"
        class="link-block-5 w-inline-block"
        @click="cancel"
        ><img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt=""
      /></a>
      <div class="success-gif-container">
        <img
          src="@/assets/timeslot-images/4386-connection-error.gif"
          loading="lazy"
          width="170"
          alt=""
        />
      </div>

      <div class="text-block text-block-success">
        {{ title }}
      </div>
      <div class="text-block-3 text-block-success">{{ message }}</div>
      <a href="#" class="button-15 red w-button" v-if="loading">
        <div class="small-loader" :style="{ textAlign: 'center' }">
          <div class>
            <div class="jt">
              <svg height="100%" viewBox="0 0 32 32" width="100%">
                <circle
                  cx="16"
                  cy="16"
                  fill="none"
                  r="14"
                  stroke-width="4"
                  style="stroke: #FFFFFF; opacity: 0.2;"
                />
                <circle
                  cx="16"
                  cy="16"
                  fill="none"
                  r="14"
                  stroke-width="4"
                  style="stroke: #FFFFFF; stroke-dasharray: 80; stroke-dashoffset: 60;"
                />
              </svg>
            </div>
          </div>
        </div>
      </a>
      <a href="#" v-else class="button-15 red w-button" @click="buttonAction"
        >Continue</a
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CancelMessageModal",
  components: {},
  props: {
    message: String,
    buttonAction: Function,
    cancel: Function,
    isOpen: { type: Boolean, default: true },
    title: String,
    loading: Boolean
  },
  computed: {
    ...mapState(["loader"])
  }
};
</script>

<style scoped>
.text-block-success {
  text-align: center;
}
.success-gif-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.red {
  background-color: #fb2c56;
}
.small-loader {
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
.small-loader .jt {
  height: 30px;
  width: 30px;
  display: inline-block;
}
.small-loader svg {
  transform: translate(50%, 50%);
  animation: spin 0.5s infinite linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
